export default {
 TITLE:'Complete the details for this share position',
 SUBTITLE:'Equity positions - Add share position' 
}